/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */
export class Skill {
    public id: string;
    public title: string;
    public color_index: number;
    public skill_set_id: number;
    public rate: number;
    public description: string;
    public base_rate: number;
}
